<template>
  <div class="pc-chat_room">
    <el-container>
      <!-- 侧边栏 -->
      <el-aside>
        <!-- 顶部区域 -->
        <div class="aside_top">
          <div class="user_info" @click="isPopupFn" v-clickoutside="closeShowSearch" v-show="$store.state.token">
            <i class="iconfont icon-bangzhuzhongxin"></i>
            <span>{{userInfo.username}}</span>
            <i class="el-icon-arrow-down"></i>
            <div class="popup" v-if="isPopup" @click.stop="fn">
              <h1>当前属于<i @click="$router.push('/upgrade_service')">{{userInfo.vip_name}}</i></h1>
              <p v-if="userInfo.vip_level===1||userInfo.words_limit!==-1">今日可提问：{{userInfo.remain_count!=-1?userInfo.remain_count+'次':'无限制'}}</p>
              <p v-if="userInfo.vip_level===1||userInfo.words_limit!==-1">每次回复：{{userInfo.words_limit!=-1?userInfo.words_limit+'字':'无限制'}}</p>
              <p v-else class="vip_expire_time">VIP到期时间:{{userInfo.vip_expire_time}}</p>
              <div class="btn_sum">
                <el-button @click="$router.push('/upgrade_service');isPopup=false">升级会员</el-button>
                <el-button @click="signOut">退出登录</el-button>
              </div>
            </div>
          </div>
          <!-- 新增聊天室 -->
          <div class="add_room" @click="addRoom">
            <i class="el-icon-plus"></i>
            <p>新建聊天室</p>
          </div>
        </div>
        <!-- 中间区域 -->
        <div class="aside_center">
          <!-- 未登录提醒 -->
          <div class="message_prompt" v-if="!$store.state.token">
            <p>您好!</p>
            <p>请<i @click="signIn">登录</i>后使用</p>
            <p>如果没有账号，点击这里<i @click="register">注册</i></p>
          </div>
          <!-- 聊天室列表 -->
          <ul class="roomList" v-else>
            <li v-for="(item,index) in AllchatRecord" :key="item.id" @click="selecRoom(item.id,index)" :class="{select:index===idx}">
              <i class="iconfont icon-xiaoxi"></i>
              <el-input v-if="isEditName&&index===editIdx" type="text" v-model="input" />
              <div class="text" v-else>
                <p v-if="item.chatName">{{item.chatName}}</p>
                <p v-else>{{item.chatMessage}}</p>
              </div>
              <!-- 编辑确定 -->
              <div class="confirm" v-if="isEditName&&index===editIdx">
                <i class="iconfont icon-duigoux" @click="confirmEdit(index)"></i>
                <i class="iconfont icon-quxiao" @click="isEditName=false"></i>
              </div>
              <!-- 取消编辑 -->
              <div class="delete" v-else>
                <i class="iconfont icon-bianji1" @click="editName(index)"></i>
                <el-popconfirm title="确认删除这个聊天室" @confirm="removeRoom(index)">
                  <el-button slot="reference" class="el-icon-delete"></el-button>
                </el-popconfirm>
              </div>
            </li>
          </ul>
        </div>
        <!-- 底部区域 -->
        <div class="aside_bottom">
          <ul>
            <li @click="$router.push('/usage_scenario')">
              <i class="iconfont icon-gongnenglan-yixuejiuyuanfuwu"></i>
              <p>应用场景</p>
            </li>
            <li @click="goToUser">
              <img src="../../assets/pc_img/chat_room_img/user icon.png" alt="user icon">
              <p>用户中心</p>
              <span>获得免费次数</span>
            </li>
            <li @click="$router.push('/help_center')">
              <img src="../../assets/pc_img/chat_room_img/help icon.png" alt="help icon">
              <p>帮助中心</p>
            </li>
            <li @click="$router.push('/upgrade_service')">
              <img src="../../assets/pc_img/chat_room_img/upgrade icon.png" alt="upgrade icon">
              <p>升级服务</p>
              <span>新人优惠</span>
            </li>
            <li @click="$router.push('/about_us')" v-if="$store.state.version!==3">
              <img src="../../assets/pc_img/chat_room_img/About us.png" alt="About us">
              <p>关于我们</p>
            </li>
            <li v-if="$store.state.token" @click="signOut">
              <img src="../../assets/pc_img/chat_room_img/out icon.png" alt="out icon">
              <p>退出</p>
            </li>
            <li v-else @click="signIn">
              <!-- <img src="../../assets/pc_img/chat_room_img/out icon.png" alt="out icon"> -->
              <i class="iconfont icon-denglu"></i>
              <p>登录</p>
            </li>
          </ul>
          <p>ui {{$store.state.edition}}</p>
        </div>
      </el-aside>
      <!-- 主体内容 -->
      <el-main>
        <div class="logo_text" v-if="isLogo">
          <h1>ChatAI <i>中文</i></h1>
          <!-- v-if="$store.state.cid!=='113'" -->
          <p >Powered by OpenAI API 3.5 turbo & 4.0</p>
        </div>
        <!-- 通知 -->
        <div class="notice" v-clickoutside="closeNotice" v-show="$route.path=='/ask_answer' && $store.state.token">
          <span class="icon" @click="showNotice=!showNotice">
            <i class="el-icon-bell"></i>
            <sup v-if="notice.un_read!==0">{{notice.un_read}}</sup>
          </span>
          <!-- 通知列表 -->
          <div :class="['notice_box',{'notice_box_show':showNotice}]">
            <div class="notice_box_header">
              <span>最新公告</span>
            </div>
            <div class="notice_box_body" v-if="notice.list.length" @scroll="scrollNotice">
              <div class="notice_item" v-for="(item,index) in notice.list" :key="item.id" @click="openNotice(index)">
                <i class="dot" v-if="item.is_read==0"></i>
                <p>{{item.content}}</p>
                <p style="text-align: right;">
                  <span>{{item.createtime}}</span>
                </p>
              </div>
            </div>
            <div v-else class="noNotice">
              <span>暂无通知</span>
            </div>
          </div>
          <!-- 通知详情 -->
          <el-dialog :visible.sync="showNoticeDetail" width="400px" top="30vh" :modal="false">
            <div style="padding:0 20px;">
              <p style="text-indent: 25px;">{{detail.content}}</p>
            </div>
            <span slot="footer">{{ detail.createtime }}</span>
          </el-dialog>
        </div>
        <!-- 路由出口 -->
        <router-view />
        <!-- 声明 -->
        <!-- <p class="declare">
          <span v-if="$store.state.version!==3">本网站由小桔计算机运营</span> |
          <i @click="open('https://beian.miit.gov.cn/#/')">{{$store.state.filings}}</i> |
          <i @click="open('https://www.chat-gpt-ai.cn/privacy.html')" v-if="$store.state.version!==3">隐私协议</i>
        </p> -->
      </el-main>
    </el-container>
    <!-- 优惠弹出框 -->
    <div class="preferential_pup" v-if="isPreferential">
      <div class="preferential_content" >
        <span class="btn" @click="$router.push('/upgrade_service');closePreferential()"></span>
        <i class="iconfont icon-cuowu" title="关闭" @click="closePreferential"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { chatUserInfo } from '@/api/login'
import { chatNotice, chatReadNotice } from '@/api/ask_answer'
import clickoutside from '@/utils/clickoutside'
export default {
  name: 'PCchatRoom',
  metaInfo: {
    meta: [
      {
        // set meta
        name: 'keyWords',
        content: '聊天室'
      },
      {
        name: 'description',
        content: '这是聊天室'
      }
    ]
  },
  data () {
    return {
      isPopup: false,
      idx: null,
      // 是否显示名称
      isLogo: true,
      // 是否开启编辑聊天室名称
      isEditName: false,
      // 当前编辑的聊天室
      editIdx: null,
      // 输入的聊天室名称
      input: null,
      // 关闭优惠弹出层
      isPreferential: false,
      // 通知列表
      notice: {
        un_read: 0,
        count: 0,
        list: []
      },
      detail: {
        id: '',
        title: '',
        content: '',
        is_read: '',
        createtime: ''
      },
      showNoticeDetail: false,
      showNotice: false,
      // 通知分页
      noticePage: {
        page_index: 1,
        page_size: 10
      },
      scrollBottom: false
    }
  },
  computed: {
    ...mapState(['AllchatRecord', 'userInfo', 'roomId'])
  },
  created () {
    // 初始化
    const arr = this.AllchatRecord.map(item => {
      if (!item.chatModel) {
        item.chatModel = '3.5'
      }
      return item
    })
    this.$store.commit('setAllchatRecord', arr)
    // 分享邀请注册
    if (this.$route.query.invite_code && !this.$store.state.token) {
      this.$store.commit('setInvitationCode', this.$route.query.invite_code)
      this.$store.commit('login/setSign', 2)
      this.$store.commit('login/setIsShow', true)
    }
    // 重新获取用户信息
    if (this.$store.state.token) {
      this.getUserInfo()
    }
    this.$store.commit('setRoomId', this.AllchatRecord[0].id)
    if (this.AllchatRecord[0].chatRecord.length) {
      this.addRoom()
    }
  },
  methods: {
    ...mapMutations(['setRoomId']),
    // 登录
    signIn () {
      this.$store.commit('login/setIsShow', true)
      this.$store.commit('login/setSign', 1)
    },
    // 注册
    register () {
      this.$store.commit('login/setIsShow', true)
      this.$store.commit('login/setSign', 2)
    },
    // 点击dom外 关闭弹出层
    closeShowSearch () {
      this.isPopup = false
    },
    fn () { },
    // 新增聊天室
    addRoom () {
      if (!this.$store.state.token) {
        this.$store.commit('login/setIsShow', true)
        this.$store.commit('login/setSign', 1)
        return
      }
      const date = new Date()
      const id = date.getFullYear() + Math.floor(Math.random() * 100).toString()
      const arr = this.AllchatRecord
      // id 相同 更换ID
      if (arr.some((item) => item.id === id)) {
        this.addRoom()
        return
      }
      arr.unshift({
        id,
        chatRecord: [],
        messageArr: [],
        chatMessage: 'chat room',
        prompt: '',
        isNot: true,
        chatModel: '3.5'
      })
      arr.forEach((item, index) => {
        if (index) {
          item.roomIdx++
        }
      })
      this.$store.commit('setAllchatRecord', arr)
      this.setRoomId(id)
      this.idx = 0
    },
    // 切换聊天室
    selecRoom (id, index) {
      this.$router.push('/ask_answer')
      this.setRoomId(id)
      this.idx = index
    },
    // 去用户中心
    goToUser () {
      if (!this.$store.state.token) {
        this.$store.commit('login/setIsShow', true)
        this.$store.commit('login/setSign', 1)
        return
      }
      this.$router.push('/user_center')
    },
    // 退出登录
    signOut () {
      this.$store.dispatch('signOut')
      this.$router.push('/')
    },
    // 开启用户信息弹出层
    isPopupFn () {
      this.isPopup = !this.isPopup
    },
    // 删除聊天室
    removeRoom (index) {
      const arr = this.AllchatRecord
      arr.splice(index, 1)
      if (arr.length === 0) {
        arr.push({
          id: '202301',
          chatRecord: [
          ],
          messageArr: [],
          chatMessage: 'chat room',
          prompt: '',
          isNot: true,
          chatModel: '3.5'
        })
      }
      this.$store.commit('setRoomId', arr[0].id)
      this.$store.commit('setAllchatRecord', arr)
      localStorage.setItem('AllchatRecord', JSON.stringify(arr))
    },
    // 获取用户信息
    async getUserInfo () {
      const res = await chatUserInfo()
      this.$store.commit('setUserInfo', res.data)
      localStorage.setItem('userInfo', JSON.stringify(res.data))
    },
    // 开启编辑聊天室名称
    editName (index) {
      this.isEditName = true
      this.editIdx = index
    },
    // 确定编辑
    confirmEdit (index) {
      if (!this.input) {
        this.isEditName = false
        return
      }
      const arr = this.AllchatRecord
      arr[index].chatName = this.input
      this.$store.commit('setAllchatRecord', arr)
      localStorage.setItem('AllchatRecord', JSON.stringify(arr))
      this.isEditName = false
      this.input = null
    },
    // 关闭优惠弹出层
    closePreferential () {
      this.isPreferential = false
      localStorage.setItem('isPreferential', false)
    },
    // 获取通知列表
    async getNoticeList () {
      try {
        const res = await chatNotice(this.noticePage)
        if (res.code === 200) {
          this.notice = res.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    closeNotice () {
      this.showNotice = false
    },
    // 查看notice
    async openNotice (index) {
      const item = this.notice.list[index]
      this.showNoticeDetail = true
      this.detail = item
      if (item.is_read !== 0) return
      this.notice.list[index].is_read = 1
      if (this.notice.un_read > 0) {
        this.notice.un_read--
      }
      try {
        const res = await chatReadNotice({
          notice_id: item.id
        })
        if (res.code !== 200) {
          this.notice.list[index].is_read = 0
          this.notice.un_read++
        }
      } catch (e) {
        console.log(e)
      }
    },
    async scrollNotice (e) {
      const dom = e.target
      const height = dom.offsetHeight
      const scrollTop = dom.scrollTop
      const scrollHeight = dom.scrollHeight
      if (scrollTop + height >= scrollHeight && !this.scrollBottom) {
        this.scrollBottom = true
        const div = document.createElement('div')
        div.innerHTML = '<span><i class="el-icon-loading"></i>加载中</span>'
        div.style.cssText = `
          line-height: 30px;
          color: #ddd;
          text-align: center;
        `
        dom.appendChild(div)
        if (this.notice.count <= this.notice.list.length) {
          div.innerHTML = '<span>没有数据了</span>'
          // setTimeout(() => {
          //   div.remove()
          //   this.scrollBottom = false
          // }, 2000)
          return
        }
        try {
          this.noticePage.page_index++
          const res = await chatNotice(this.noticePage)
          if (res.code === 200) {
            let list = this.notice.list
            list = list.concat(res.data.list)
            this.notice.list = list
            this.scrollBottom = false
            div.remove()
          }
        } catch (e) {
          console.log(e)
        }
      }
    }
  },
  directives: {
    clickoutside
  },
  watch: {
    roomId: {
      handler () {
        this.idx = this.AllchatRecord.findIndex((item) => item.id === this.roomId)
      },
      immediate: true
    },
    $route: {
      handler (to) {
        if (to.path === '/about_us') {
          this.isLogo = false
        } else {
          this.isLogo = true
        }
      },
      immediate: true
    },
    userInfo: {
      handler () {
        this.isPreferential = JSON.parse(localStorage.getItem('isPreferential'))
        if (this.isPreferential === undefined || this.isPreferential === null) {
          this.isPreferential = this.$store.state.userInfo.has_vip_discount
        }
      },
      deep: true
    }
  },
  mounted () {
    this.getNoticeList()
  }
}
</script>

<style lang="less" scoped>
  @import url('./chat_room.less');
</style>
